// material ui
import { Theme } from '@mui/material';

export const paperCustomization = {
  MuiPaper: {
    styleOverrides: {
      root: ({ theme }: { theme: Theme }) => ({
        borderRadius: 8,
        backgroundColor:
          theme.palette.mode === 'dark'
            ? theme.palette.grey[1000]
            : theme.palette.grey[0],
      }),
    },
  },
};
